<footer>
  <div class="container">
      <div class="row">
          <div class="col-sm-12 col-lg-6 col-xxl-6 my-2 sm-img"><a href="https://www.allegion.com/corp/en/index.html"
                  target="_blank" rel="noopener"><img src="assets/images/allegion-logo.svg" alt="Allegion logo" class="img-fluid"></a>
          </div>
          <div class="col-sm-12 col-lg-6 col-xxl-6 my-2">
              <div class="row">
                  <div class="col-6 col-sm-6 col-lg-6 col-xxl-6">
                      <p class="text pt-2">
                          <a href="https://www.stanleyaccess.com/contact" target="_blank" class="text link-header" rel="noopener">
                              <b>CONTACT US</b> &nbsp;<i class="bi bi-arrow-right-circle"></i>
                          </a>
                  </p>
                  </div>
                  <div class="col-6 col-sm-6 col-lg-6 col-xxl-6 text-left">
                      <p>
                          <span class="pe-3">
                              <a href="tel:+18007222377" class="text link-header"> <i class="bi bi-telephone-fill"></i>&nbsp; 1-800-7-ACCESS</a>
                          </span>
                      </p>
                  </div>
              </div>
              <div class="row">
                  <div class="col-6 col-sm-6 col-lg-6 col-xxl-6">
                      <p class="text pt-2 text-justify">
                          For emergency service requests after hours and weekends:
                      </p>
                  </div>
                  <div class="col-6 col-sm-6 col-lg-6 col-xxl-6 text-left">
                      <p class="mt-3">
                          <span class="pe-3">
                              <a href="tel:+1888-366-7444" class="text link-header"><i class="bi bi-telephone-fill"></i>&nbsp; 1-888-DOOR444</a>
                          </span>
                      </p>
                  </div>
              </div>
          </div>
          <div class="col-lg-5">
              <p class="text pt-2">© {{currentYear}} ALLEGION ACCESS TECHNOLOGIES LLC</p>
              <p class="copy-right">All rights reserved. STANLEY ACCESS TECHNOLOGIES is used with permission.
                  STANLEY is the property of Stanley Logistics L.L.C.
                    <span> | Version: {{appVersion}}</span>
              </p>
          </div>
          <div class="col-lg-7">
              <ul class="nav copy-rights-nav">
                  <li class="nav-item cursor">
                      <a class="nav-link" href="https://www.stanleyaccess.com/terms-use" target="_blank" rel="noopener">
                          TERMS OF USE
                      </a>
                  </li>
                  <li class="nav-item cursor">
                      <a class="nav-link" href="https://www.stanleyaccess.com/privacy-statement" target="_blank" rel="noopener">
                          PRIVACY STATEMENT
                      </a>
                  </li>
                  <li class="nav-item cursor">
                      <a class="nav-link" href="https://us.allegion.com/en/resources/cybersecurity/disclosure-policy.html" target="_blank" rel="noopener">
                          Vulnerability Disclosure
                      </a>
                  </li>
                  <li class="nav-item cursor">
                      <a class="nav-link" href="https://www.stanleyaccess.com/cookie-policy" target="_blank" rel="noopener">COOKIE POLICY</a>
                  </li>
                  <li class="nav-item cursor">
                      <a class="nav-link" routerLink="/user">HOME</a>
                  </li>
              </ul>
          </div>
      </div>
  </div>
</footer>
